module.exports = __webpack_public_path__ + "img/jean_louis_marchon.3c65fd4e.png";